// src/pages/Modals/CreateDivision.js
import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  CircularProgress,
  Box,
} from "@mui/material";
import api from "../../api/api";
import Swal from "sweetalert2";

const CreateDivision = ({ open, handleClose, onDivisionCreated }) => {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("access");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    setTimeout(async () => {
      try {
        const config = { headers: { Authorization: `Bearer ${token}` } };
        const response = await api.post("/api/users/divisions/", { name }, config);

        if (response.status === 201) {
          Swal.fire({
            icon: "success",
            title: "Division Created",
            timer: 2000,
            showConfirmButton: false,
          });
          onDivisionCreated?.(); // Notify SubjectFormModal to refresh
          handleClose();
          setName("");
        }
      } catch (err) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: err.response?.data?.name || "Something went wrong!",
        });
      } finally {
        setLoading(false);
      }
    }, 3000);
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Add a New Division</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          {loading ? (
            <Box textAlign="center">
              <p>Please wait...</p>
              <CircularProgress />
            </Box>
          ) : (
            <TextField
              label="Division Name"
              fullWidth
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          )}
        </DialogContent>
        <DialogActions>
          {!loading && (
            <>
              <Button onClick={handleClose} color="secondary">Cancel</Button>
              <Button type="submit" color="primary">Submit</Button>
            </>
          )}
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CreateDivision;

